/* eslint-disable linebreak-style */
import React, { Component } from "react";
import { NavLink, withRouter, Switch } from "react-router-dom";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import { isWebview } from "../../util/generalFunction";

class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `#${history.location.pathname}`; // get current path

    const subMenuLi = document.querySelectorAll(".sub-menu > li");
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function(event) {
        event.stopPropagation();
      };
    }

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function(event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains("open"))) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
        event.stopPropagation();
      };
    }

    const activeLi = document.querySelector(`a[href="${pathname}"]`); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest = (el, selector) => {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(fn => {
        if (typeof document.body[fn] === "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  };

  render() {
    return (
      <CustomScrollbars style={{ height: "100vh" }}>
        <ul className="nav-menu">
          <li className="menu no-arrow">
            <NavLink to={isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/businesses"}>
              <i className="zmdi zmdi-store zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.superAdmin.business" />{" "}
              </span>
            </NavLink>
          </li>
          <li className="menu">
            <NavLink to={isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/services"}>
              <i className="zmdi zmdi-assignment-o zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.superAdmin.services" />{" "}
              </span>
            </NavLink>
            <ul className="sub-menu">
              <li className="menu no-arrow">
                <NavLink className="prepend-icon" to={isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/servicecategories"}>
                  <i className="zmdi zmdi-account-circle zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="vibo.superAdmin.servicecategories" />{" "}
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu no-arrow">
            <NavLink to={isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/customers"}>
              <i className="zmdi zmdi-male-alt zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.superAdmin.customer" />{" "}
              </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to={isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/users"}>
              <i className="zmdi zmdi-male-alt zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.superAdmin.manageUsers" />{" "}
              </span>
            </NavLink>
          </li>
          {/* <li className="menu no-arrow">
            <NavLink to="/admin/customers">
              <i className="zmdi zmdi-accounts zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.adminpages.customers" />{" "}
              </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink to="/admin/reports">
              <i className="zmdi zmdi-assignment-alert zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.adminpages.reports" />{" "}
              </span>
            </NavLink>
          </li>
          <li className="menu">
            
            <NavLink to="/admin/businessprofile">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="vibo.adminpages.settings" />
              </span>
            </NavLink>

          
            <ul className="sub-menu">
              <li className="menu no-arrow">
                <NavLink className="prepend-icon" to="/admin/businessprofile">
                  <i className="zmdi zmdi-account-circle zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="vibo.adminpages.businessProfile" />{" "}
                  </span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink className="prepend-icon" to="/admin/workinghours">
                  <i className="zmdi zmdi-group-work zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="vibo.adminpages.workinghours" />{" "}
                  </span>
                </NavLink>
              </li>
            </ul> */}
          {/* <NavLink to="/admin/settings">
            
              <span className="nav-text">
                <IntlMessages id="adminpages.settings" />{" "}
              </span>
            </NavLink>
          </li> */}
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SuperAdminSideNav/SidenavContent.js